import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { truncate, filter, take } from 'lodash';
import enhanceWithClickOutside from 'react-click-outside';
import {
  MenuItem, Dropdown, Button, Modal,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';
import SearchField from '../../../../components/search-field';

class ProducDropDown extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
      modalOpen: false,
      query: null,
    };
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleClickOutside() {
    this.setState({ open: false });
  }
  
  handleSearch(query) {
    this.setState({ query });
  }

  handleToggle(open, e, s) {
    if (open) {
      this.setState({ open });
    } else if (this.state.open && s.source === 'rootClose') {
      this.handleClickOutside();
    }
  }

  handleModalClose() {
    this.setState({ modalOpen: false });
  }

  handleSelect(product) {
    this.props.onProductSelect(product);
    this.setState({ open: false });
  }

  renderModal(toggleLabel) {
    const { modalOpen, query } = this.state;
    const { allowMultipleProducts } = this.props;

    const isSearching = query && query.length > 0;
    const allProducts = this.props.products;
    let products = [...allProducts];
    if (isSearching) {
      const re = new RegExp(query, 'i');
      products = filter(products, (product) => {
        let matchName = false;
        if (re) {
          const name = product.name || '';
          matchName = name.match(re);
        }
        return matchName;
      });
    }

    return [
      (
        <Button
          key="button"
          bsStyle="default"
          onClick={() => { this.setState({ modalOpen: true }); }}
        >
          {truncate(toggleLabel, { length: 20 })}
        </Button>
      ),
      (
        <Modal
          key="modal"
          show={modalOpen}
          onHide={this.handleModalClose}
          bsSize="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Primary Product{allowMultipleProducts ? '(s)' : ''} Considered</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              {allProducts.length > 0 &&
                <div className="well">
                  Please select the primary product{allowMultipleProducts ? '(s)' : ''} considered in this opportunity.
                </div>
              }
              {allProducts.length > 5 &&
                <div style={{ marginBottom: 15 }}>
                  <SearchField onSearch={this.handleSearch} collapsible={false} />
                </div>
              }
              {allProducts.length > 0 &&
                <div>
                  <div className="list-group" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {products.map((product) => {
                      const active = product.selected;
                      let icon = active ? 'check-square-o' : 'square-o';
                      if (!allowMultipleProducts) {
                        icon = active ? 'check-circle-o' : 'circle-o';
                      }
                      return (
                        <button
                          type="button"
                          className={`list-group-item ${active ? 'active' : ''}`}
                          key={product.id}
                          onClick={() => {
                            this.handleSelect(product);
                          }}
                        >
                          <div><Fa name={icon} /> {product.name}</div>
                        </button>
                      );
                    })}
                  </div>
                </div>
              }

              {products.length === 0 &&
                <div className="alert alert-warning">
                  {!isSearching && <div>No records found.</div>}
                  {isSearching && <div>No records found matching <code>{query}</code>.</div>}
                </div>
              }
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={this.handleModalClose}
            >
              Done
            </Button>
          </Modal.Footer>
        </Modal>
      ),
    ]
  }

  render() {
    const { products, allowMultipleProducts } = this.props;
    const { open } = this.state;
    let selectedProducts = filter(products, { selected: true });
    if (!allowMultipleProducts) {
      selectedProducts = take(selectedProducts, 1); // do not preselect
    }

    let toggleLabel = 'Select a product:';
    if (selectedProducts.length === 1) {
      toggleLabel = selectedProducts[0].name;
    } else if (selectedProducts.length > 1) {
      toggleLabel = `Products (${selectedProducts.length})`;
    }
    const total = products.length;
    if (total >= 5) {
      return this.renderModal(toggleLabel);
    }
    return (
      <Dropdown
        id="contact-products"
        onSelect={this.handleSelect}
        onToggle={this.handleToggle}
        open={open}
      >
        <Dropdown.Toggle>
          {truncate(toggleLabel, { length: 20 })}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {products.map((product) => {
            const active = product.selected;
            let icon = active ? 'check-square-o' : 'square-o';
            if (!allowMultipleProducts) {
              icon = active ? 'check-circle-o' : 'circle-o';
            }

            return (
              <MenuItem
                eventKey={product}
                active={active}
                key={product.id}
              >
                {allowMultipleProducts && <Fa name={icon} />} {product.name}
              </MenuItem>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}
ProducDropDown.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
  onProductSelect: PropTypes.func,
  allowMultipleProducts: PropTypes.bool,
};
ProducDropDown.defaultProps = {
  products: [],
  onProductSelect: () => {},
  allowMultipleProducts: true,
};

export default enhanceWithClickOutside(ProducDropDown);


